import { useContext, useEffect, useState } from "react";
import {
    Card,
    CardHeader,
    CardFooter,
    Button,
    Label,
    FormFeedback,
    Container,
    Modal,
    Row,
    Col,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
    Form,
    FormGroup,
    Input,
} from "reactstrap";
import classnames from 'classnames'
import { URL } from "../../config";
import { AuthContext } from "../../context";
// core components
import GeneralTable from '../components/GeneralTable'
import DeleteModal from '../components/DeleteModal'
import GeneralPagination from "../components/GeneralPagination";

const Tables = () => {
    const [allRecords, setallRecords] = useState()
    const [modalOpen, setModalOpen] = useState(false)
    const [deleteModal, setDeleteModal] = useState(false)
    const [activeTab, setActiveTab] = useState(1)
    const [itemID, setItemID] = useState()
    const [toCreate, setToCreate] = useState(true)
    const [oneRecord, setoneRecord] = useState([])
    const [formErrors, setFormErrors] = useState({ place_lang: [] })
    const [query, setQuery] = useState()
    const [sort, setSort] = useState({ field: "", order: "" })
    const [languages, setLanguages] = useState([])

    const authContext = useContext(AuthContext)
    const token = JSON.parse(localStorage.getItem("token"))

    const handleChange = (e, index, lang_id) => {
        let updatedData = { ...oneRecord }
        let updatedRecord = updatedData['place_lang']
        if (updatedRecord != undefined && updatedRecord[index]) {
            updatedData.place_lang = [...updatedRecord.slice(0, index), { ...updatedRecord[index], title: e.target.value }, ...updatedRecord.slice(index + 1)]
        }
        else {
            updatedData.place_lang = [...(updatedRecord || []), { title: e.target.value, lang_id: lang_id }]
        }
        setoneRecord(updatedData)
    };

    const handleQuery = (e) => {
        let value = e.target.value
        if (value.length >= 3) {
            fetchallRecords(1, null, value)
        }
        if (value.length < query?.length) {
            fetchallRecords(1)
        }
        setQuery(value)
    }

    const toggle = (index) => {
        setActiveTab(index)
    };


    const toggleCreateUpdateModal = () => {
        setModalOpen(!modalOpen)
        setoneRecord([])
        setFormErrors({place_lang: []})
        setActiveTab(1)
    }

    const toggleDeleteModal = (id) => {
        setItemID(id)
        setDeleteModal(!deleteModal)
    }

    const fetchallRecords = (page = 1, orderObj = null, query = null) => {
        let url = page > 0 ? `${URL}/placeaz/all?page=${page}` : `${URL}/placeaz/all?page=${1}`
        if (orderObj?.field) {
            url += `&field=${orderObj.field}&order=${orderObj.order}`
        }
        if (query) {
            url += `&q=${query}`
        }
        fetch(url, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`,
            },
        }).then(result => {
            if (!result.ok) throw result;
            return result.json();
        }).then(result => {
            setallRecords(result)
        }).catch(error => {
            if (error.status == 401) {
                authContext.logout()
            }
        })
    }

    const getIcon = (field) => {
        if (field === sort.field) {
            switch (sort.order) {
                case "asc":
                    return (<i className="fas fa-angle-up" />)
                case "desc":
                    return (<i className="fas fa-angle-down" />)
            }
        }
    }

    const changePage = (page) => {
        fetchallRecords(page, sort)
    }

    const handleSort = (field) => {
        let order;
        if (sort.order === "asc" && sort.field === field)
            order = "desc";
        else {
            order = "asc"
        }
        let orderObj = { field: field, order: order }
        setSort(orderObj)
        fetchallRecords(1, orderObj, query)
    }

    const deleteplace = (id) => {
        fetch(`${URL}/place/delete/${id}`, {
            method: 'DELETE',
            headers: {
                'Authorization': `Bearer ${token}`,
            },
        }).then(result => {
            if (!result.ok) throw result;
            return result.json();
        }).then(result => {
            fetchallRecords(allRecords['page'], sort)
            toggleDeleteModal()
        }).catch(error => {
            if (error.status == 401) {
                authContext.logout()
            }
        })
    }

    const validate = () => {
        let obj_lang = oneRecord.place_lang
        let errors = { ...formErrors }
        let generalValid = true
        if (obj_lang && obj_lang[0]) {
            if (obj_lang[0].title === undefined || obj_lang[0].title == '') {
                errors.place_lang = [{ title: 'Bu xananı doldurmaq lazımdır!' }]
                generalValid = false
            }
        }
        else {
            errors.place_lang = [{ title: 'Bu xananı doldurmaq lazımdır!' }]
            generalValid = false
        }
        setFormErrors(errors)
        return generalValid
    }

    const validateUpdate = () => {
        let obj_lang = oneRecord.place_lang
        let errors = { ...formErrors }
        let generalValid = true
        if (obj_lang) {
            for (let i = 0; i < obj_lang.length; i++) {
                let errorMessage = ""
                let valid = true
                if (obj_lang[i].title === undefined || obj_lang[i].title == '') {
                    errorMessage = 'Bu xananı doldurmaq lazımdır!'
                    valid = false
                    generalValid = false
                }
                errors.place_lang[i] = { title: errorMessage, valid: valid }
            }
        }
        else {
            for (let i = 0; i < obj_lang.length; i++) {
                errors.place_lang[i] = { title: 'Bu xananı doldurmaq lazımdır!', valid: false }
                errors.valid = false
                generalValid = false
            }
        }
        setFormErrors(errors)
        return generalValid
    }

    const submitForm = () => {
        let validationCheck = toCreate ? validate : validateUpdate
        if (validationCheck()) {
            let url = toCreate ? `${URL}/place/` : `${URL}/place/update/${itemID}`
            let method = toCreate ? 'POST' : 'PUT'
            const authorization = 'Bearer ' + token
            fetch(url, {
                method: method,
                headers: {
                    'Authorization': authorization,
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(oneRecord)
            }).then(result => {
                if (!result.ok) throw result;
                return result.json();
            }).then(result => {
                fetchallRecords(allRecords['current_page'], sort)
                toggleCreateUpdateModal()

            }).catch(error => {
                if (error.status == 401) {
                    authContext.logout()
                }
            })
        }
    }

    const createModal = () => {
        setToCreate(true)
        toggleCreateUpdateModal()
    }

    const updateModal = (id) => {
        fetch(`${URL}/place/${id}`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`,
            },
        }).then(result => {
            if (!result.ok) throw result;
            return result.json();
        }).then(result => {
            setoneRecord({ place_lang: result['place_lang'] })
        }).catch(error => {
            if (error.status == 401) {
                authContext.logout()
            }
        })
        setItemID(id)
        setToCreate(false)
        toggleCreateUpdateModal()
    }

    const getLanguages = () => {
        fetch(`${URL}/language/all`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`,
            },
        }).then(result => {
            if (!result.ok) throw result;
            return result.json();
        }).then(result => {
            setLanguages(result)
        }).catch(error => {
            if (error.status == 401) {
                authContext.logout()
            }
        })
    }


    useEffect(() => {
        getLanguages()
        fetchallRecords()
    }, [])


    return (
        <>
            {/* Page content */}
            <Container fluid>
                {/* Table */}
                <Row>
                    <div className="col mt-5 offset-md-2">
                        <Card className="shadow">
                            <CardHeader className="border-0 d-flex justify-content-between">
                                <h3 className="mb-0">Şəhərlər</h3>
                                <FormGroup>
                                    <Input
                                        id="search"
                                        onChange={(e) => handleQuery(e)}
                                        value={query}
                                        placeholder="Axtarış..."
                                        type="text"
                                    />
                                </FormGroup>
                                <Button className="btn-icon btn-3" onClick={() => createModal()} color="primary" type="button">Şəhər əlavə et</Button>
                            </CardHeader>
                            <GeneralTable
                                columns={[
                                    { title: 'ID', field: 'id' },
                                    { title: 'Adı', field: 'title' }
                                ]}
                                handleSort={handleSort}
                                getIcon={getIcon}
                                toggleUpdateModal={updateModal}
                                toggleDeleteModal={toggleDeleteModal}
                                data={allRecords}
                            />
                            <CardFooter className="py-4">
                                <GeneralPagination
                                    data={allRecords}
                                    changePage={changePage}
                                />
                            </CardFooter>
                        </Card>
                    </div>
                </Row>

                <Modal
                    className="modal-dialog-centered"
                    isOpen={modalOpen}
                    toggle={() => toggleCreateUpdateModal()}
                    backdrop={'static'}
                >
                    <div className="modal-header">
                        <h5 className="modal-title" id="exampleModalLabel">
                            Menu yaratmaq
                        </h5>
                        <button
                            aria-label="Close"
                            className="close"
                            data-dismiss="modal"
                            type="button"
                            onClick={() => toggleCreateUpdateModal()}
                        >
                            <span aria-hidden={true}>×</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <Row>
                            <Col xs="6" sm="4" md="4">
                                <Nav tabs vertical pills>
                                    {languages && languages.map((item, index) => (
                                        <div style={{ marginTop: "10px" }}>
                                            <NavItem>
                                                <NavLink
                                                    className={classnames({ active: activeTab === index + 1 })}
                                                    onClick={() => {
                                                        toggle(index + 1);
                                                    }}
                                                >
                                                    {String(item['short_name']).toUpperCase()}
                                                    {formErrors.place_lang[index]?.title.length > 0 &&
                                                        <i style={{ color: 'red' }} className="ni ni-fat-remove" />
                                                    }
                                                </NavLink>
                                            </NavItem>
                                        </div>
                                    ))}
                                </Nav>
                            </Col>
                            <Col xs="6" sm="6" md="6">
                                <TabContent activeTab={activeTab}>
                                    {languages && languages.map((language_data, index) => (
                                        <TabPane tabId={index + 1}>
                                            <Form>
                                                <Row>
                                                    <Col>
                                                        <FormGroup>
                                                            <h5>Cari dil: {String(language_data['short_name']).toUpperCase()}</h5>
                                                            <Label>Ad</Label>
                                                            <Input
                                                                invalid={formErrors.place_lang[index]?.title.length > 0}
                                                                id="exampleFormControlInput1"
                                                                name='title'
                                                                onChange={(e) => handleChange(e, index, language_data['id'])}
                                                                value={oneRecord['place_lang'] && oneRecord['place_lang'][index]?.title}
                                                                placeholder="Şəhərin adi..."
                                                                type="text"
                                                            />

                                                            <FormFeedback>
                                                                {formErrors?.place_lang[index]?.title}
                                                            </FormFeedback>
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                            </Form>
                                        </TabPane>
                                    ))}
                                </TabContent>
                            </Col>
                        </Row>
                    </div>
                    <div className="modal-footer">
                        <Button
                            color="secondary"
                            data-dismiss="modal"
                            type="button"
                            onClick={() => toggleCreateUpdateModal()}
                        >
                            Bağla
                        </Button>
                        <Button color="primary" type="button" onClick={() => submitForm()}>
                            {toCreate ? 'Əlavə et' : 'Düzəliş et'}
                        </Button>
                    </div>
                </Modal>



                <DeleteModal
                    isOpen={deleteModal}
                    toggleDeleteModal={toggleDeleteModal}
                    title={"Şəhəri silmək"}
                    bodyText={"Bu şəhəri silmək istədiyinizə əminsiniz?"}
                    itemID={itemID}
                    deleteAction={deleteplace} />
            </Container>
        </>
    );
};

export default Tables;
